import Axios from 'axios';
import appConfig from '../config/appConfig';

let cachedToken = null;
let tokenExpiry = null;

/**
 * Get an M2M (Machine-to-Machine) access token for external API calls
 * Caches the token until it expires
 * @returns {Promise<string>} The access token
 */
export async function getM2MAccessToken() {
  // Check if we have a valid cached token
  if (cachedToken && tokenExpiry && Date.now() < tokenExpiry) {
    return cachedToken;
  }

  // console.log('Attempting to get M2M access token');
  try {
    // Build the token endpoint URL
    const tokenEndpoint = `https://${appConfig.cognito.USER_POOL_M2M}.auth.${appConfig.cognito.REGION}.amazoncognito.com/oauth2/token`;

    // Create Basic Auth header from client credentials
    const credentials = `${appConfig.cognito.M2M_CLIENT_ID}:${appConfig.cognito.M2M_CLIENT_SECRET}`;
    const basicAuth = btoa(credentials);

    // console.log(tokenEndpoint);
    // console.log(credentials);
    // console.log(basicAuth);
    // Make the token request
    const response = await Axios.post(
      tokenEndpoint,
      `grant_type=client_credentials&scope=${appConfig.cognito.M2M_SCOPE}`,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Basic ${basicAuth}`,
        },
      },
    );

    // Cache the token
    cachedToken = response.data.access_token;
    // Set expiry to 1 minute before actual expiry to be safe
    tokenExpiry = Date.now() + (response.data.expires_in - 60) * 1000;

    console.log('M2M token obtained and cached');

    return cachedToken;
  } catch (error) {
    console.error('Error getting M2M access token:', error);
    throw error;
  }
}

export async function getApiUrl() {
  console.log('Attempting to get API URL');
  try {
    const apiUrl = `${appConfig.cognito.API_URL}`;
    console.log('API URL:', apiUrl);
    return apiUrl;
  } catch (error) {
    console.error('Error getting API URL:', error);
    throw error;
  }
}

/**
 * Clear the cached token (useful for testing or forced refresh)
 */
export function clearCachedToken() {
  cachedToken = null;
  tokenExpiry = null;
}
